import useAxiosClient from '@blueshift-ui/fetch/dist/hooks/use-axios-client';
import useMutation from '@blueshift-ui/fetch/dist/hooks/use-mutation';

interface UseClaimFreeMonthParams {
  subscriptionId?: string | null;
}

interface UseClaimFreeMonthRequest {
  sendEmailConfirmation: boolean;
}

function useClaimFreeMonth({ subscriptionId }: UseClaimFreeMonthParams) {
  const { makeMutation: makeRequestClaimFreeMonth, isLoading } = useMutation<
    UseClaimFreeMonthRequest,
    void
  >({
    mutationKey: 'claim-free-month',
    mutationOptions: {
      meta: {
        client: useAxiosClient(),
      },
    },
    request: {
      body: {
        promotion: {
          code: 'FREEMONTH',
          reason: 'Free Month Concession',
          promotion_id: '34d764ce-25ff-4f6d-9ccc-0b2c7483a6b0',
        },
      },
      method: 'PATCH',
      url: `/v1/subscriptions/${subscriptionId}`,
    },
  });

  return { makeRequestClaimFreeMonth, isLoading };
}

export default useClaimFreeMonth;
